module.exports = __webpack_public_path__ + "static/media/logo_footer_bim.d298e01a.png";